import RealTimeReport_Table from './container';

export default RealTimeReport_Table;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/index.js